import React, { FC } from 'react';

type TTerritoryNewPostIconProps = {
  stroke?: string;
  fill?: string;
};

export const TerritoryNewPostIcon: FC<TTerritoryNewPostIconProps> = ({ stroke = '#D97706', fill = '#FFFBEB' }) => (
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20.5" cy="20" r="20" fill={fill} />
    <path
      d="M19 12H12C11.4696 12 10.9609 12.2107 10.5858 12.5858C10.2107 12.9609 10 13.4696 10 14V28C10 28.5304 10.2107 29.0391 10.5858 29.4142C10.9609 29.7893 11.4696 30 12 30H26C26.5304 30 27.0391 29.7893 27.4142 29.4142C27.7893 29.0391 28 28.5304 28 28V21"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.5 10.5C26.8978 10.1022 27.4374 9.87866 28 9.87866C28.5626 9.87866 29.1022 10.1022 29.5 10.5C29.8978 10.8978 30.1213 11.4374 30.1213 12C30.1213 12.5626 29.8978 13.1022 29.5 13.5L20 23L16 24L17 20L26.5 10.5Z"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
